<div [ngClass]="{ 'allow-to-show-banner': (allowToShow$ | async) === true}">
  <rh-header-gcs-menu></rh-header-gcs-menu>
</div>
